import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    CanLoad,
    Route,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import {AuthService} from './auth.service';
import {ParamService} from './param.service';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
    constructor(
        private authService: AuthService,
        private router: Router,
        private paramService: ParamService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // const url = state.url.replace('?.html=', '').replace('.html', '');
        const urlWithoutParams = '';
        const params = '';
        return this.checkLogin(urlWithoutParams, params);
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        console.log('activate child');

        return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {
        console.log('can load');

        const url = `/${route.path}`;
        return this.checkLogin(url, '');
    }

    checkLogin(url: string, params: any): boolean {
        if (this.authService.getUserInfo()) {
            return true;
        }
        return false;
    }

}
